import type { BaseCompany } from '~/domain/shared/company/models/Company'

export enum CompanyField {
  Address = 'address',
  Birthday = 'birthday',
  CustomerCategoryId = 'customer_category_id',
  Email = 'email',
  Identifier = 'identifier',
  IE = 'ie',
  CNPJ = 'cnpj',
  CompanyName = 'company_name',
  MainPhone = 'main_phone',
  MobilePhone = 'mobile_phone'
}

export enum CustomerField {
  Address = 'address',
  Birthday = 'birthday',
  CPF = 'cpf',
  CustomerCategoryId = 'customer_category_id',
  Email = 'email',
  Gender = 'gender',
  Identifier = 'identifier',
  MainPhone = 'main_phone',
  MobilePhone = 'mobile_phone',
  RG = 'rg'
}

export interface RequiredFieldsToRegisterERPSettings {
  company: CompanyField[]
  customer: CustomerField[]
}

export interface CustomerERPSettings {
  isAllowedProvideNewCustomerForAllCompanies: boolean
  companies: BaseCompany[]
  isEnabledNotifySyncCustomer: boolean
  requiredFieldsToRegister?: RequiredFieldsToRegisterERPSettings
}
